export class CategoryCardinalityStruct {
  constructor(
    public catCode: string,
    public isTeam: boolean,
  ) {};
}
